// @flow
import type { Action } from 'app/common/redux/types';

export type State = {
  facebookAutoLoginStatus: string,
};

const facebookAutoLoginReducer = (
  state: State = { facebookAutoLoginStatus: 'null' },
  action: Action,
): State => {
  if (
    action.type === 'FB_AUTOLOGIN_NOT_AUTHORIZED' ||
    action.type === 'FB_AUTOLOGIN_AUTH_EXPIRED' ||
    action.type === 'FB_AUTOLOGIN_CONNECTED' ||
    action.type === 'FB_AUTOLOGIN_UNKNOWN'
  ) {
    return { facebookAutoLoginStatus: action.type };
  }
  return state;
};

export default facebookAutoLoginReducer;
